import { Button, LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { useToggleState } from '@cian/react-utils';
import { ManifestModal } from '../ManifestModal';
import { Header } from '../Header';
import { clsx } from 'clsx';
import { useCallback } from 'react';
import { caReadManifest } from '../tracking';
import { VK_VIDEO_LINK } from 'shared/constants/links';

export const Manifest: React.FC = () => {
  const { state: isManifestModalOpen, toggle: toggleManifestModal } = useToggleState();

  const device = useDeviceType();

  const isDesktop = device === 'desktop';

  const handleOpenManifest = useCallback(async () => {
    caReadManifest();

    toggleManifestModal();
  }, [toggleManifestModal]);

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Header />
      <div className={styles['wrapper']}>
        <div className={styles['banner']}>
          <div className={styles['title']}>
            Гости бронируют. <span className={styles['text-color']}>На Циан</span>
          </div>
        </div>
        <div className={styles['manifest']}>
          <div className={styles['manifest-title']}>Манифест Циан Посуточно</div>
          <div className={styles['manifest-text']} />
          <div className={styles['btns-container']}>
            <div className={styles['btn']}>
              <Theme theme="onOverlay">
                <Button theme="fill_secondary" onClick={handleOpenManifest} size={isDesktop ? 'L' : 'M'} fullWidth>
                  Читать Манифест
                </Button>
              </Theme>
            </div>
            <div className={styles['btn']}>
              <Theme theme="onOverlay">
                <LinkButton
                  theme="fill_secondary"
                  href={VK_VIDEO_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  size={isDesktop ? 'L' : 'M'}
                  fullWidth
                >
                  Смотреть видео
                </LinkButton>
              </Theme>
            </div>
          </div>
        </div>
      </div>
      <ManifestModal open={isManifestModalOpen} onOpenChange={toggleManifestModal} />
    </div>
  );
};
